/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerJournalEntriesInner
 */
export interface GetOrganizationsDeals200ResponseInnerJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'invalidTaxCodeCause': GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'description': string | null;
}

export const GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum];


